import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Modal from 'react-responsive-modal';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {getComapreProductDetail} from '../../../actions/productCompare'
import ReactReadMoreReadLess, { small } from "react-read-more-read-less";
import {wishlistDefault} from  '../../common/MangoIcons';
import compareImage from '../../../assets/images/compare.png';
import noProductImage from '../../../assets/images/noProductImg_420x420.jpg';




class CollectionProductItem extends Component {

    constructor() {
        super()

        this.state = {
            open: false,
            stock: 'InStock',
            quantity: 1,
            image: ''
        }
    }

    variantStyle = (color) => {
        if (color && color === '#FFF' || color === '#FFFFFF' || color === 'White' || color === 'WHITE' || color === 'white')
            return ({ backgroundColor: color, border: '1px solid #777', width: 16, height: 16 })
        else
            return ({ backgroundColor: color, width: 16, height: 16 })
    }

    onClickHandle(img) {
        this.setState({ image: img });
    }
    

    onCloseModal = () => {
        this.setState({ open: false });
    };

    minusQty = () => {
        if (this.state.quantity > 1) {
            this.setState({ stock: 'InStock' })
            this.setState({ quantity: this.state.quantity - 1 })
        }
    }

    //handle compare onclick in mobile view 
     mobileCompare = (pc) => {
        const myArrayFromLocalStorage = localStorage.getItem('myArray')
if (myArrayFromLocalStorage && myArrayFromLocalStorage.length) {
const myArray = JSON.parse(myArrayFromLocalStorage)
myArray.indexOf(pc) === -1 && myArray.push(pc)
localStorage.setItem('myArray', JSON.stringify(myArray))


}
else {
    const myArray = [pc]
    localStorage.setItem('myArray', JSON.stringify(myArray))
}
        

        

     var  myArray   = localStorage.getItem('myArray');
     const product_codes = JSON.parse(myArray)

        const options = {
            connection_id : this.props.connection_id,
            product_code : product_codes
        }
      
        this.props.getComapreProductDetail(options) 
        window.open('./compare');
   
     
       
      };

    plusQty = () => {
        if (this.props.product.stock >= this.state.quantity) {
            this.setState({ quantity: this.state.quantity + 1 })
        } else {
            this.setState({ stock: 'Out of Stock !' })
        }
    }
    changeQty = (e) => {
        this.setState({ quantity: parseInt(e.target.value) })
    }

    handlePopup = (pc) => {

        const myArrayFromLocalStorage = localStorage.getItem('myArray')
if (myArrayFromLocalStorage && myArrayFromLocalStorage.length) {
const myArray = JSON.parse(myArrayFromLocalStorage)
myArray.indexOf(pc) === -1 && myArray.push(pc)
localStorage.setItem('myArray', JSON.stringify(myArray))


}
else {
    const myArray = [pc]
    localStorage.setItem('myArray', JSON.stringify(myArray))
}
        

        /* var pcs = JSON.parse(localStorage["datas"]);
        pcs.indexOf(pc) === -1 && pcs.push(pc); */
        /* localStorage['product_code'] = JSON.stringify(pcs) */

     var  myArray   = localStorage.getItem('myArray');
     const product_codes = JSON.parse(myArray)

        const options = {
            connection_id : this.props.connection_id,
            product_code : product_codes
        }
      
        this.props.getComapreProductDetail(options) 
        this.setState({ open: true });
   
    };
    removeCompare=(pc)=>{
        document.getElementById(pc).remove();
        var  myArray   = localStorage.getItem('myArray');

     const product_codes = JSON.parse(myArray)
    
     for( var i = 0; i < product_codes.length; i++){ 
     
         if ( product_codes[i] === pc) { 
     
             product_codes.splice(i, 1); 
         }
     
     }


localStorage.setItem('myArray', JSON.stringify(product_codes))


    }
    render() {
        var cp = [];
      const { product,compareDetail, colSize,symbol,related, onAddToCartClicked, onAddToWishlistClicked, presentURL } = this.props;
      // onAddToCompareClicked
        // let RatingStars = []
        // for(var i = 0; i < product.rating; i++) {
        //     RatingStars.push(<i className="fa fa-star" key={i}></i>)
        // }
        // 
        return (
            <div className="product-box" style={colSize===6 ? {marginTop:'0px'}:{marginTop:0}}>
                <div className="img-wrapper">
                    <div className="lable-block">
                        {(product.ACP_SKU_OVERLAY_TEXT == 'New') ? <span className="lable3">new</span> : ''}
                        {(product.ACP_SKU_OVERLAY_TEXT == 'On Sale') ? <span className="lable4">on sale</span> : ''}
                    </div>
                    <div className="front">
                        
                        <Link to={`${process.env.PUBLIC_URL}/PD/${product.QOL_LOT_CD}`} >
                        {product.SKU_IMAGE && product.SKU_IMAGE.length > 40 && product.SKU_IMAGE !== '\/images\/noProductImg_45x45.jpg' ? 
                            <img  style={colSize===6 ?{display:'block',margin:'0 auto',width:'85%'}:{display:'block',margin:'0 auto'}}
                            src={`${product.variants ?
                                    this.state.image ? this.state.image : product.SKU_IMAGE
                                    : product.SKU_IMAGE
                                }`}
                            className="img-fluid category-product-image"
                            alt="" /> : <img  style={colSize === 6 ? {width:'85%',display:'block',margin:'0 auto',padding:65}:{display:'block',margin:'0 auto',padding:15}}
                            src={noProductImage}
                            className="img-fluid category-product-image"
                            alt="" /> }</Link>
                    </div>
                    <div className="cart-info cart-wrap">
                        {/* <button title="Add to cart" onClick={onAddToCartClicked}>
                            <i className="fa fa-shopping-cart" aria-hidden="true"></i>
                        </button>
*/}                       
                        
                        {/* <a href="javascript:void(0)" data-toggle="modal"
                            data-target="#quick-view"
                            title="Quick View"
                            onClick={this.onOpenModal}
                        ><i className="fa fa-expand" aria-hidden="true"></i></a> */}
                        {/* <Link to={`${process.env.PUBLIC_URL}/compare`} title="Compare" >
                            <i className="fa fa-refresh" aria-hidden="true"></i></Link> */}
                    </div>
                    {/* {product.variants ?
                        <ul className="product-thumb-list">
                            {product.variants[0].PDM_VARIANT_DETAIL.map((variant_color, i) =>
                                <li className={`grid_thumb_img ${(variant_color.SKU_IMAGE === this.state.image) ? 'active' : ''}`} key={i}>
                                    <a href="javascript:void(0)" title="Add to Wishlist">
                                        <img src={`${variant_color.SKU_IMAGE}`} onClick={() => this.onClickHandle(variant_color.SKU_IMAGE)} />
                                    </a>
                                </li>)}
                        </ul> : ''} */}

                </div>
                {/* <div className='row' style={colSize === 6 ? {marginTop:'0px'}:{marginTop:0}}><div className='col' style={{textAlignLast:'end'}}></div>
                        <div className='col' style={related && related == 'yes' ? {paddingTop:5}:{paddingTop:2}} onClick={window.innerWidth > 560 ? () =>this.handlePopup( product.SKU_PRODUCT_CD):() =>this.mobileCompare( product.SKU_PRODUCT_CD) }>
                            <img src={compareImage} style={{width:20,cursor:'pointer'}} /></div>
                            </div> */}
                    
              <div className="product-detail" style={{textAlign:'center'}}>
                    <div>
                        {/* <div className="rating">
                                {RatingStars}
                            </div> */}
                        <Link to={`${process.env.PUBLIC_URL}/PD/${product.QOL_LOT_CD}`} style={{color:'black'}}>
                        <h5 style={{marginBottom: 2}}>{product.PRODUCT_SHORT_DESC}</h5>
                        { parseInt(product.MAX_PRICE) > parseInt(product.MIN_PRICE) ?
                         <h5 style={{marginBottom: 2}}>{symbol}{product.MIN_PRICE}&nbsp;&nbsp;-&nbsp;&nbsp;{symbol}{product.MAX_PRICE}
                      {/*    {(product.QOL_PRICE > product.QOL_SELLING_PRICE) ? <del><span className="money">&nbsp;{product.QOL_PRICE}</span></del>: ''} */}
                         </h5> :
                        <h5 style={{marginBottom: 2}}>{symbol}{product.MAX_PRICE}
                      {/*   {(product.QOL_PRICE > product.QOL_SELLING_PRICE) ? <del><span className="money">&nbsp;{product.QOL_PRICE}</span></del>: ''} */}
                        </h5> }
                        
                        {/* {product.variants ? */}
                            <ul className="color-variant" style={{paddingTop: 0,marginBottom:0}}>
                               {product.NOOF_COLOR ? product.NOOF_COLOR +'Colours' : product.SKU_VARIANT1_VALUE_DESC }
                                {/* {product.variants[0].PDM_VARIANT_DETAIL.length >1 && product.variants[0].PDM_VARIANT_DETAIL.map((variant_color, i) => {
                                    return (
                                        <li style={variant_color.SKU_VARIANT_HEXCODE ? this.variantStyle(variant_color.SKU_VARIANT_HEXCODE) : this.variantStyle('#000')}
                                            key={i}
                                            title={variant_color.SKU_VARIANT_VALUE_DESC}
                                            onClick={() => this.onClickHandle(variant_color.SKU_IMAGE)}
                                        ></li>)
                                })} */}
                                {/* {
                                    product.variants[0] 
                                    ? 
                                        product.variants[0].PDM_VARIANT_DETAIL.length <=1 
                                        ?
                                            product.variants[0].PDM_VARIANT_DETAIL[0]
                                                ? 
                                                    `${product.variants[0].PDM_VARIANT_DETAIL[0].SKU_VARIANT_VALUE_DESC}` 
                                                :
                                                    `${product.variants[0].PDM_VARIANT_DETAIL.length} Colours`
                                        : 
                                            `${product.variants[0].PDM_VARIANT_DETAIL.length} Colours`
                                    :
                                        `${product.variants[0].PDM_VARIANT_DETAIL.length} Colours`
                                }*/}
                            
                            </ul> 
                            {/* : ''}  */}
                            </Link>
                            
                    </div>
                    {/* <br/> */}
                    <div >
                        {
                        
                        product.SKF_PRODUCT_GROUP_DESC && product.SKF_PRODUCT_GROUP_DESC != null   ?
                        related && related === 'yes' ?  '' : 
                    <ReactReadMoreReadLess
                charLimit={90} 
                readMoreText={<span style={{color:'black',fontWeight:700}}>Read More&nbsp;<i style={{fontSize:'small'}} className='fa fa-plus' /></span>}
                readLessText={<span style={{color:'black',fontWeight:700}}>Read Less&nbsp;<i style={{fontSize:'small'}} className='fa fa-minus' /></span>}
            >
                {product.SKF_PRODUCT_GROUP_DESC}
            </ReactReadMoreReadLess>
  
            : '' }
                    </div>
                </div>
                <Modal open={this.state.open} onClose={this.onCloseModal} center>           
                    <div className="modal-dialog modal-lg modal-dialog-centered" role="document">
                        <div className="modal-content quick-view-modal">
                            <div className="modal-body">
                               
                                                               <table style={{width:'max-content'}}>
                                                                 
                                                               <tbody style={{    textAlign: 'center'}}> 
                                                               <tr>
                                                               <td>
                                                                           &nbsp;
                                                                       </td>
                                                                       <td style={{padding:30}}>
                                                                           Title
                                                                       </td>
                                                                       <td style={{height:130}}>
                                                                       Image
                                                                       </td>
                                                                       
                                                                       <td style={{paddingTop:40}}>
                                                                           Brand
                                                                       </td>
                                                                       <td>Price
                                                                           
                                                                       </td><td>Details

                                                                       </td>
                                                                       {related && related === 'yes' ? '' :
                                                                       <td>
                                                                           Option
                                                                       </td> }
                                                                       <td style={related && related === 'yes' ? {paddingTop:20}:{padding:25}}>
                                                                           Product Code
                                                                       </td>
                                                                       <td>
                                                                       Description
                                                                           
                                                                        </td>

                                                               </tr>
                                    {compareDetail.map((productCompare,index) =>{
                                return(     <tr  role='row' id={productCompare.SKU_PRODUCT_CD} >
<td onClick={()=>this.removeCompare(productCompare.SKU_PRODUCT_CD)} style={{cursor:'pointer'}}>Remove</td>

                                        
                                        

                                            <td style={{padding:30}}>{productCompare.SKU_DESC}</td>
                                            <td  >
                                            {productCompare.SKU_IMAGE && productCompare.SKU_IMAGE.length > 50 && productCompare.SKU_IMAGE !== '\/images\/noProductImg_45x45.jpg' ? 
                                        <img  style={{width:123}}
                                                src={productCompare.SKU_IMAGE}
                                                alt="" className="img-fluid" /> : 
                                                <img  style={{width:123}}
                                                src={noProductImage}
                                                alt="" className="img-fluid" /> }
                                
                                </td>
                                <td >{productCompare.SKU_BRD_DESC}</td>
                                <td>{productCompare.MAX_PRICE}</td>
                                <td>{productCompare.SKU_PRODUCT_DETAIL_DESC}</td>

                                {related && related === 'yes' ? '' :
                                    <td><Link to={`${process.env.PUBLIC_URL}/PD/${productCompare.QOL_LOT_CD}`} >
                                        <button className='btn btn-solid' style={{padding: 3,fontSize: 'small'}}>SELECT OPTIONS</button>
                                        </Link>
                                        </td> }
                                  <td>
                                      {productCompare.SKU_PRODUCT_CD}
                                  </td>
                                    <td style={{width:400}}>{productCompare.SKF_PRODUCT_GROUP_DESC}</td>
                                    </tr>
                                    
                                   
                                   )
                                })

                            }
                             </tbody>
                                
                                </table> 
                            
                            </div>
                        </div>
                    </div>
                     
                </Modal>
            </div>
        )
    }
}


const mapStateToProps = (state) => ({
    connection_id: state.tenant.connection_id,
    compareDetail : state.productCompare.compareDetail
})

const mapDispatchToProps = dispatch => bindActionCreators({
    getComapreProductDetail,
}, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CollectionProductItem);
